import {
  SET_ALL_DATA_OF_ADMIN_APPOINTMENTS,
  SET_APPOINTMENTS_ADMIN_APPOINTMENTS,
  SET_FILTERED_ADMIN_APPOINTMENTS,
  SET_PAGES_DATA_ADMIN_APPOINTMENTS,
  SET_SHOULD_UPDATE_ADMIN_APPOINTMENTS,
  RESET_ALL_ADMIN_APPOINTMENTS_DATA,
  PREPEND_NEW_APPOINTMENT_ADMIN,
} from "./type";

export const setAllDataOfAdminAppointments = (data) => {
  return {
    type: SET_ALL_DATA_OF_ADMIN_APPOINTMENTS,
    payload: data,
  };
};

export const setAppointmentsAdminAppointments = (appointments) => {
  return {
    type: SET_APPOINTMENTS_ADMIN_APPOINTMENTS,
    payload: appointments,
  };
};

export const setFilteredAdminAppointments = (filtered) => {
  return {
    type: SET_FILTERED_ADMIN_APPOINTMENTS,
    payload: filtered,
  };
};

export const setPagesDataAdminAppointments = (data) => {
  return {
    type: SET_PAGES_DATA_ADMIN_APPOINTMENTS,
    payload: data,
  };
};

export const setShouldUpdateAdminAppointments = (shouldUpdate) => {
  return {
    type: SET_SHOULD_UPDATE_ADMIN_APPOINTMENTS,
    payload: shouldUpdate,
  };
};

export const resetAllAdminAppointmentsData = () => {
  return {
    type: RESET_ALL_ADMIN_APPOINTMENTS_DATA,
  };
};

export const prependNewAppointment = (appointment) => ({
  type: PREPEND_NEW_APPOINTMENT_ADMIN,
  payload: appointment,
});
